import { Link } from "react-router-dom";
import CategoriesMenu from "../../../notes/components/menu/CategoriesMenu";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotesListFilterController from "../../../notes/components/NotesListFilterController";
import { RootState } from "../../../../store/store";
import categoriesApi from "../../../notes/api/CategoriesApi";
import TagsMenu from "../../../notes/components/menu/TagsMenu";
import { setNotesCounter, setNotesFilter } from "../../../../store/NotesStore";
import tagsApi from "../../../notes/api/TagsApi";
import { updateAccountTagsStore } from "../../../../store/functions";
import { FormattedMessage } from "react-intl";
import { toggleOpenMainSideBar } from "../../functions";
import notesApi from "../../../notes/api/NotesApi";
import NotesCount from "../../../notes/model/NotesCount";

class SelectedSection {
    type: string;
    title: string;
    constructor(type: string, title: string) {
        this.type = type;
        // this.entity = entity;
        this.title = title;
    }
}

const MainSideBarMenu = () => {
    const dispatch = useDispatch();

    const [selectedSection, setSelectedSection ] = useState<SelectedSection|undefined>(undefined)
    const [totalNotesCount, setTotalNotesCount ] = useState<number>(0)

    const filter = useSelector((state: RootState) => state.notes.filter);
    const notesCount:NotesCount[] = useSelector((state: RootState) => state.notes.notesCounter)
    
    const loadNotesCallBack = useCallback(() => {
        if (filter && "categoryId" in filter) {
            let categoryId = filter["categoryId"];
            categoriesApi.getCategory(categoryId)
                .then((category) => {
                    setSelectedSection(new SelectedSection("category", category.title))
                })
        } else
        if (filter && "tagId" in filter) {
            let tagId = filter["tagId"];
            tagsApi.getAccountTag(tagId)
                .then((accountTag) => {
                    setSelectedSection(new SelectedSection("tag", accountTag.name))
                })            
        }

        notesApi.getNotesCount()
        .then((data) => {
            dispatch(setNotesCounter(data))
        });
    }, [filter]);

    useEffect(() => {
        updateAccountTagsStore();
    }, []);

    useEffect(() => {
        loadNotesCallBack();
    }, [loadNotesCallBack]);

    useEffect(() => {
        let count = 0;
        notesCount.forEach((it:NotesCount) => {
            count = count + it.count;
        })
        setTotalNotesCount(count);
    }, [notesCount]);    

    const getSelectedSectionTitle = () => {
        if (selectedSection === undefined) {
            return <span><FormattedMessage id="all_notes"/></span>
        }
        else if(selectedSection.type == "category"){
            return <span><i className="fa-regular fa-folder"></i>{selectedSection.title}</span>
        }
        else if(selectedSection.type == "tag"){
            return <span># {selectedSection.title}</span>
        }

    }

    return <>
        <NotesListFilterController/>
        {/* <div className={"section-selection-header"} onClick={toggleShowSelectSectionBlock}>
            <h3>{getSelectedSectionTitle()}</h3> <i className={'fa-solid ' + (showSelectSectionBlock ? 'fa-chevron-up' : 'fa-chevron-down')}></i>
        </div> */}

        <div className={"section-selection-header"} >
            <Link className="btn btn-danger btn-color w-100" to="/notes/create" onClick={() => toggleOpenMainSideBar(null)}>
                <FormattedMessage id="create_note"/>
            </Link>
        </div>

        {/* <div className={"section-selection " + (showSelectSectionBlock ? "open" : "")}> */}
        <div className={"section-selection open"}>
            <div className="sidebar-menu">
                <div className="sidebar-menu-block">
                    <ul className="list-group">                        
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="ms-2 me-auto">
                                <Link to={'/notes'} className="nav-link fw-bold"
                                    onClick={(e) => {
                                          dispatch(setNotesFilter({}));
                                          toggleOpenMainSideBar(null)
                                          return false;
                                        }}
                                    ><FormattedMessage id="all_notes"/></Link>
                            </div>
                            <span className="badge bg-primary rounded-pill">{totalNotesCount}</span>
                        </li>

                        {/* <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="ms-2 me-auto">
                                <div className="fw-bold">Без разделов</div>
                            </div>
                            <span className="badge bg-primary rounded-pill">0</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="ms-2 me-auto">
                                <div className="fw-bold">Избранное</div>
                            </div>
                            <span className="badge bg-primary rounded-pill">0</span>
                        </li> */}
                    </ul>                    
                </div>
                <div className="sidebar-menu-block">
                    <CategoriesMenu/>
                </div>
                <div className="sidebar-menu-block">
                    <TagsMenu/>
                </div>
            </div>
        </div>    
    </>
}

export default MainSideBarMenu;